import { gql } from '@lcs/shared/api';

export const getAccountsQuery = gql`
   query GetAccounts($first: Int!, $filters: String, $after: String, $orderingOptions: [OrderingOption!]) {
      accountsConnection(first: $first, filters: $filters, after: $after, orderingOptions: $orderingOptions) {
         totalCount
         pageInfo {
            hasNextPage
            endCursor
            hasPreviousPage
            startCursor
         }
         items {
            accountId
            name
            shortName
            lcsAccountNumber
            activeStartDate
            activeEndDate
            logLevelChanged
            extensionsConnection {
               items {
                  isArchived
               }
            }
            pstnLineLimit
            extensionCount
            phoneNumberCount
            phoneNumbersConnection {
               items {
                  isArchived
               }
            }
            logLevelId
         }
      }
   }
`;

export const getAccountIdsQuery = gql`
   query GetAccountIds($first: Int!, $filters: String, $after: String, $orderingOptions: [OrderingOption!]) {
      accountsConnection(first: $first, filters: $filters, after: $after, orderingOptions: $orderingOptions) {
         totalCount
         pageInfo {
            hasNextPage
            endCursor
            hasPreviousPage
            startCursor
         }
         items {
            accountId
         }
      }
   }
`;
